import { t } from 'i18next';
import { SitrepSelectedType } from 'src/types/mixed.type';

export type PropsType = {
  selectedUnitData: SitrepSelectedType;
};

export const tableContents = () => [
  {
    key: 'identification',
    title: t('hymotsc.tableColumns.Identification'),
  },
  {
    key: 'uzunIsim',
    title: t('hymotsc.tableColumns.longName'),
  },
  {
    key: 'konum',
    title: t('hymotsc.tableColumns.location'),
  },
  {
    key: 'istikamet',
    title: t('hymotsc.tableColumns.bearing'),
  },
  {
    key: 'taraf.kisaIsim',
    title: t('hymotsc.tableColumns.side'),
  },
  {
    key: 'etmenSinifi.kisaIsim',
    title: t('hymotsc.tableColumns.faction'),
  },
  {
    key: 'etmenTuru.kisaIsim',
    title: t('hymotsc.tableColumns.prototype'),
  },
  {
    key: 'faaliyeti',
    title: t('hymotsc.tableColumns.posture'),
  },
  {
    key: 'hareketSafhasi',
    title: t('hymotsc.tableColumns.subPosture'),
  },
  {
    key: 'angajmanKurali',
    title: t('hymotsc.tableColumns.engagementRule'),
  },
  {
    key: 'ustIsletenEtmenVtId',
    title: t('hymotsc.tableColumns.higherAgent'),
  },
  {
    key: 'ikmalindenSorumluEtmenVtId',
    title: t('hymotsc.tableColumns.supplyingAgent'),
  },
  {
    key: 'hacim',
    title: t('hymotsc.tableColumns.volume'),
  },
  {
    key: 'hiz',
    title: t('hymotsc.tableColumns.speed'),
  },
  {
    key: 'bindirilmisMi',
    title: t('hymotsc.tableColumns.embarked'),
  },
  {
    key: 'savunma.hazirlikSuresi',
    title: t('hymotsc.tableColumns.defensePrepTime'),
  },
  {
    key: 'savunma.savunmaYuzdesi',
    title: t('hymotsc.tableColumns.defensePercentage'),
  },
  {
    key: 'insanZayiatOrani',
    title: t('hymotsc.tableColumns.humanCasualtyRate'),
  },
  {
    key: 'otonomZayiatOrani',
    title: t('hymotsc.tableColumns.autonomousCasualtyRate'),
  },
  {
    key: 'magicIkmal',
    title: t('hymotsc.tableColumns.magicSupply'),
  },
  {
    key: 'beklemeSuresi',
    title: t('hymotsc.tableColumns.remainingTime'),
  },
  {
    key: 'echelon',
    title: 'ECHELON',
  },
  {
    key: 'forceIdentifier',
    title: 'FORCE',
  },
  {
    key: 'owner',
    title: 'OWNER',
  },
  {
    key: 'aisDurumu',
    title: 'AIS',
  },
];

export const activityContents = () => [
  {
    key: 'disiplinVeMoralParametresi',
    title: t('hymotsc.tableColumns.disciplineAndMorale'),
  },
  {
    key: 'egitimSeviyesiParametresi',
    title: t('hymotsc.tableColumns.training'),
  },
  {
    key: 'meskunMahalParametresi',
    title: t('hymotsc.tableColumns.urbanWarfare'),
  },
];

export enum TasimaTipi {
  'STANDART' = 0,
  'DOCK' = 1,
  'TOWING' = 2,
  'POW' = 3,
}
